import { render, staticRenderFns } from "./litter-volunteer-detail.vue?vue&type=template&id=e1cb2d4e&scoped=true"
import script from "./litter-volunteer-detail.vue?vue&type=script&lang=js"
export * from "./litter-volunteer-detail.vue?vue&type=script&lang=js"
import style0 from "./litter-volunteer-detail.vue?vue&type=style&index=0&id=e1cb2d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cb2d4e",
  null
  
)

export default component.exports